module.exports = __webpack_public_path__ + "static/img/05951361.3410dfac.png";